import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import { Screen } from 'src/components';
import { LINKS } from 'src/constants';
import _ from 'lodash';
import MobileOneTimeTransactionsSuccess from './mobileOneTimeTransactionsSuccess';
import DesktopOneTimeTransactionsSuccess from './desktopOneTimeTransactionsSuccess';
import styles from './_oneTimeTransactionsSuccess.module.scss';

class OneTimeTransactionsSuccess extends Component {
  componentDidMount() {
    setTimeout(() => {
      const { status } = this.props;
      const isSuccess = status === 'success';
      if (isSuccess) window.location.href = LINKS.SURVEY_LINK;
    }, 3000);
  }

  render() {
    const { checkout, status, reason } = this.props;
    let checkoutDetail = checkout?.checkoutPayment || {};
    if (_.isEmpty(checkoutDetail)) checkoutDetail = checkout?.checkoutDetail || {};

    return (
      <>
        <Screen>
          <div className={cx(styles['sip-transactions-success'])}>
            <div className={styles['mobile']}>
              <MobileOneTimeTransactionsSuccess
                checkoutDetail={checkoutDetail}
                status={status}
                reason={reason}
              />
            </div>
            <div className={styles['desktop']}>
              <DesktopOneTimeTransactionsSuccess
                checkoutDetail={checkoutDetail}
                status={status}
                reason={reason}
              />
            </div>
          </div>
        </Screen>
      </>
    );
  }
}

export default withRouter(OneTimeTransactionsSuccess);
